
import React from "react";
import { Group } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface SavedTeamsProps {
  setActiveTab: (tab: string) => void;
}

export const SavedTeams: React.FC<SavedTeamsProps> = ({ setActiveTab }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Group className="h-5 w-5 text-indigo-500" />
          Saved Teams
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="text-center p-12 text-gray-500">
          <Group className="h-16 w-16 mx-auto mb-4 text-gray-300" />
          <h3 className="text-xl font-medium mb-2">No saved teams yet</h3>
          <p>Your saved teams will appear here.</p>
          <Button 
            className="mt-4 bg-indigo-600 hover:bg-indigo-700"
            onClick={() => setActiveTab("build")}
          >
            Create Your First Team
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
